export const SET_ERROR = 'questionnaire/SET_ERROR';
export const SET_LEAD = 'questionnaire/SET_LEAD';
export const SET_CUR_MODE = 'questionnaire/SET_MODE';
export const SET_LEAD_WIZARD = 'questionnaire/SET_LEAD_WIZARD';
export const SET_LEAD_WIZARD_ERROR = 'questionnaire/SET_LEAD_WIZARD_ERROR';

